import { email, firstName, lastName, phone, privacyAgreement } from '@/schemas';
import * as Yup from 'yup';

const MEMBER_AMOUNT_ERROR_MESSAGE =
  'Bitte geben Sie die Anzahl der Mitglieder ein.';

const DESIRED_DATE_ERROR_MESSAGE =
  'Das Datum muss im richtigen Format angegeben werden.';

const courseRequestFormSchema = Yup.object({
  firstName,
  lastName,
  email,
  phone,
  memberAmount: Yup.number()
    .typeError(MEMBER_AMOUNT_ERROR_MESSAGE)
    .positive(MEMBER_AMOUNT_ERROR_MESSAGE)
    .required(MEMBER_AMOUNT_ERROR_MESSAGE),
  desiredDate: Yup.string().required(DESIRED_DATE_ERROR_MESSAGE),
  privacyAgreement,
  marketingAgreement: Yup.boolean(),
});

export default courseRequestFormSchema;
